
import { DateService, DateUnit } from "@app/services/date.service";
import * as angular from "angular";
import { Subscription } from "rxjs";
import { VideoStatus } from "./enums/VideoStatus";
import { VideoEntryService } from "./services/video-entry.service";
import { VideoReviewService } from "./services/video-review.service";
import { VideoEntryUtils } from "./utils/video-entry-utils";

export class VideoPageController {
    private unseenVideoCountUpdatedSub = Subscription.EMPTY;
    private downloadVideoCountUpdatedSub = Subscription.EMPTY;

    numVideos = 0;
    numNewVideos = 0;
    numEvents = 0;
    numDownloads = null;

    showDiagnostics = false;

    static $inject = ["$scope", "$interval", "videoReviewService", "videoEntryService", "dateService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $interval: angular.IIntervalService,
        private readonly videoReviewService: VideoReviewService,
        private readonly videoEntryService: VideoEntryService,
        private readonly dateService: DateService) {

        this.updateData();

        this.$interval(() => { this.updateData(); }, 60 * 1000);

        this.downloadVideoCountUpdatedSub = this.videoEntryService.downloadVideoCountUpdated$.subscribe(() => {
            this.updateData(true);
        })

        this.unseenVideoCountUpdatedSub = this.videoReviewService.unseenVideoCountUpdated$.subscribe(() => {
            this.updateData(true);
        })
    }

    $onDestroy(): void {
        this.unseenVideoCountUpdatedSub?.unsubscribe();
        this.downloadVideoCountUpdatedSub?.unsubscribe();
    }

    // ---

    private updateData(invalidateCache = false) {
        const defaultTimePeriod = 7; // days
        const now = new Date();
        const start = this.dateService.addOrSubtractTime(now, -defaultTimePeriod, DateUnit.Day);
        const end = now;

        this.videoEntryService.getAllVideosEntries(start, end).then(videoEntries => {

            this.numVideos = videoEntries.filter(v => v.Status == VideoStatus.Downloaded).length;
            this.numNewVideos = videoEntries.filter(v => VideoEntryUtils.isUnseen(v)).length;
            this.numEvents = videoEntries.filter(v => v.Status == VideoStatus.EventOnly).length;
        });

        this.videoEntryService.getVideoEntriesRequestedWithMappings({ invalidateCache: true }).then(videoEntries => {
            this.numDownloads = videoEntries.filter(v => VideoEntryUtils.isDownloading(v)).length;

            if (this.numDownloads === 0) {
                this.numDownloads = null;
            }
        });
    }
}
